import { memo } from "react"

/** The way back from an open idea, chat or list to the Agent page. */
export const BreadcrumbBack = memo(({ onClick }: { onClick: () => void }) => (
	<button
		type="button"
		data-testid="agent-breadcrumb-back"
		onClick={onClick}
		className="-ml-1 -mr-1 flex-none rounded px-1 py-0.5 text-secondary hover:bg-gray-100 dark:hover:bg-gray-800"
	>
		Agent
	</button>
))
